(function ($, _, Backbone, Drupal) {

  Drupal.gary.AppStateModel = Backbone.Model.extend({
    screenSize: '',
    scrollTop: 0,
    scrollDir: '',
  });

}(jQuery, _, Backbone, Drupal));
